import './featured-person.css';

export default ({details, type}) => {
    if(!details) {
      return <></>
    }
    return <article className={`featured-person ${type === 'card'? 'featured-person-card': ''}`}>
      <div className="featured-person-title-container">
        <div className="featured-person-image">
        <img  src={details.person.imageUrl}/>
        </div>
        <div className="featured-person-title">
          <h2>{details.title}</h2>
          <div>{details.person?.fullName}</div>
          <div>{details.person?.designation}</div>
        </div>
      </div>
      <div className="featured-person-detail">
        <div className="featured-person-content" dangerouslySetInnerHTML={{ __html: details.content }}/>
      </div>
    </article>
}